export default "__VITE_ASSET__3412732c__"